import { reactive } from 'vue'

export const storeHeader = reactive({
  title: 'Eronor.com',
  text: '',
  classTitle: 'default-siege'
})
